import { useState } from 'react'
import { Alert, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { jobRecordKey } from '../api/jobDescription'
import { JOBS_QUERY_KEY, updateJobStatus, type JobStatus } from '../api/jobs'
import { t } from '../i18n'

/**
 * s69 / 2s (Marcelo 29/10/2026 10:30, "nao consigo editar se esta ativa ou inativa"): a SITUACAO do cargo na empresa,
 * editavel por quem tem job_architecture.job.write -- so Ativo <-> Inativo. Arquivado nao volta (regra do Dominio,
 * ADR-0018 D4) e aparece so como texto. Grava na hora (PATCH /api/jobs/{id}/status).
 */
export function JobStatusField({ jobId, status, pode }: { jobId: string; status: JobStatus; pode: boolean }) {
  const qc = useQueryClient()
  const [erro, setErro] = useState(false)
  const m = useMutation({
    mutationFn: (s: 'active' | 'inactive') => updateJobStatus(jobId, s),
    onMutate: () => setErro(false),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: jobRecordKey(jobId) })
      void qc.invalidateQueries({ queryKey: JOBS_QUERY_KEY })
    },
    onError: () => setErro(true),
  })
  if (!pode || status === 'archived')
    return (
      <Typography variant="body2" component="span" data-testid="job-status-valor">
        {t.jobs.statuses[status]}
      </Typography>
    )
  return (
    <Stack spacing={0.5} alignItems="flex-start">
      <TextField
        select
        size="small"
        value={status}
        disabled={m.isPending}
        onChange={(e) => m.mutate(e.target.value as 'active' | 'inactive')}
        slotProps={{ htmlInput: { 'aria-label': t.jobRecord.fieldStatus, 'data-testid': 'job-status-select' } }}
        sx={{ minWidth: 130 }}
      >
        <MenuItem value="active">{t.jobs.statuses.active}</MenuItem>
        <MenuItem value="inactive">{t.jobs.statuses.inactive}</MenuItem>
      </TextField>
      {erro && (
        <Alert severity="warning" data-testid="job-status-erro">
          {t.jobRecord.statusSaveError}
        </Alert>
      )}
    </Stack>
  )
}
